import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal } from '@bwoty-web/ui-kit';
import ExcursionList from '../../../common/excursionList';
import './tileContent.scss';

const ExcursionContent = ({
  tile,
  isExpanded = false,
  close,
  siteId,
  wvId,
}) => {
  const classes = classNames('tile-popup', `tile-popup-${tile.key}`);

  return (
    <Modal
      className={classes}
      isOpen={isExpanded}
      size="m"
      onClose={() => close(tile?.key)}
      heading={tile?.header}
    >
      <div className="tile-popup-content-container">
        {tile?.labels?.preamble?.length > 0 && (
          <div className="gw-tile-excursion-preamble">
            {tile?.labels?.preamble}
          </div>
        )}
        <ExcursionList
          excursions={tile?.excursions}
          readMoreLabel={tile?.labels?.readMoreLabel}
          siteId={siteId}
          wvId={wvId}
        />
      </div>
    </Modal>
  );
};

ExcursionContent.propTypes = {
  tile: PropTypes.shape({
    key: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    excursions: PropTypes.arrayOf(PropTypes.shape({})),
    labels: PropTypes.shape({
      readMoreLabel: PropTypes.string,
      preamble: PropTypes.arrayOf(PropTypes.string),
      esgSymbolInfo: PropTypes.string,
    }),
  }).isRequired,
  isExpanded: PropTypes.bool,
  close: PropTypes.func.isRequired,
  siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  wvId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ExcursionContent;
